import eSymbolIndex from '../symbols/eSymbolIndex';

export const eAnimationNames = {
  EAN_ANTISIPATOR: 'animation',
  EAN_POPUP_SHINE: 'pop_up_shine',
  EAN_COIN_FLIP: 'coin_flip',
};

export const eBigWinAnimationNames = {
  START: 'big_win_start',
  IDLE: 'big_win_idle',
};

export const eMegaWinAnimationNames = {
  START: 'mega_win_start',
  IDLE: 'mega_win_idle'
};

export const eEpicWinAnimationNames = {
  START: 'epic_win_start',
  IDLE: 'epic_win_idle'
};

export const eJackpotWinAnimationNames = {
  IDLE: 'jackpot'
};


export const eSymbolAnimationNames = {
  [`ESAN_${eSymbolIndex.ESI_WILD}_2`]: '_WLD_girl',
  [`ESAN_${eSymbolIndex.ESI_WILD}_3`]: '_WLD_girl2',
  [`ESAN_${eSymbolIndex.ESI_WILD}_4`]: '_WLD_girl3',
  [`ESAN_${eSymbolIndex.ESI_WILD}_5`]: '_WLD_girl4',
  [`ESAN_${eSymbolIndex.ESI_WILD}_6`]: '_WLD_girl5',
  [`ESAN_${eSymbolIndex.ESI_KALYNA}_2`]: 'kalyna',
  [`ESAN_${eSymbolIndex.ESI_KALYNA}_3`]: 'kalyna2',
  [`ESAN_${eSymbolIndex.ESI_KALYNA}_4`]: 'kalyna3',
  [`ESAN_${eSymbolIndex.ESI_KALYNA}_5`]: 'kalyna4',
  [`ESAN_${eSymbolIndex.ESI_KALYNA}_6`]: 'kalyna5',
  [`ESAN_${eSymbolIndex.ESI_SABER}_2`]: 'sabers',
  [`ESAN_${eSymbolIndex.ESI_SABER}_3`]: 'sabers2',
  [`ESAN_${eSymbolIndex.ESI_SABER}_4`]: 'sabers3',
  [`ESAN_${eSymbolIndex.ESI_SABER}_5`]: 'sabers4',
  [`ESAN_${eSymbolIndex.ESI_SABER}_6`]: 'sabers5',
  [`ESAN_${eSymbolIndex.ESI_ROOSTER}_2`]: 'rooster',
  [`ESAN_${eSymbolIndex.ESI_ROOSTER}_3`]: 'rooster2',
  [`ESAN_${eSymbolIndex.ESI_ROOSTER}_4`]: 'rooster3',
  [`ESAN_${eSymbolIndex.ESI_ROOSTER}_5`]: 'rooster4',
  [`ESAN_${eSymbolIndex.ESI_ROOSTER}_6`]: 'rooster5',
  [`ESAN_${eSymbolIndex.ESI_PALYANYTSYA}_2`]: 'palyanitsya',
  [`ESAN_${eSymbolIndex.ESI_PALYANYTSYA}_3`]: 'palyanitsya2',
  [`ESAN_${eSymbolIndex.ESI_PALYANYTSYA}_4`]: 'palyanitsya3',
  [`ESAN_${eSymbolIndex.ESI_PALYANYTSYA}_5`]: 'palyanitsya4',
  [`ESAN_${eSymbolIndex.ESI_PALYANYTSYA}_6`]: 'palyanitsya5',
  [`ESAN_${eSymbolIndex.ESI_PYSANKA}_2`]: 'pysanka',
  [`ESAN_${eSymbolIndex.ESI_PYSANKA}_3`]: 'pysanka2',
  [`ESAN_${eSymbolIndex.ESI_PYSANKA}_4`]: 'pysanka3',
  [`ESAN_${eSymbolIndex.ESI_PYSANKA}_5`]: 'pysanka4',
  [`ESAN_${eSymbolIndex.ESI_PYSANKA}_6`]: 'pysanka5',
  [`ESAN_${eSymbolIndex.ESI_WHEAT}_2`]: 'wheet',
  [`ESAN_${eSymbolIndex.ESI_WHEAT}_3`]: 'wheet2',
  [`ESAN_${eSymbolIndex.ESI_WHEAT}_4`]: 'wheet3',
  [`ESAN_${eSymbolIndex.ESI_WHEAT}_5`]: 'wheet4',
  [`ESAN_${eSymbolIndex.ESI_WHEAT}_6`]: 'wheet5',
  [`ESAN_${eSymbolIndex.ESI_SCATTER}_2`]: '_SCA_hawk',
  [`ESAN_${eSymbolIndex.ESI_SCATTER}_3`]: '_SCA_hawk2',
  [`ESAN_${eSymbolIndex.ESI_SCATTER}_4`]: '_SCA_hawk3',
  [`ESAN_${eSymbolIndex.ESI_SCATTER}_5`]: '_SCA_hawk4',
  [`ESAN_${eSymbolIndex.ESI_SCATTER}_6`]: '_SCA_hawk5',
};
